import React from "react";
import { Link, useNavigate } from "react-router-dom";
import useAuth from './useAuth';
import logo from './001.png';
import AutoLogout from './AutoLogout';

const Navbar = () => {
    const navigate = useNavigate();
    useAuth();
    const uni_code = localStorage.getItem("emp_code");
    console.log("checker",uni_code);
    let value = localStorage.getItem('emp_code');
    console.log("check",value);
    const handleLogout = () => {
        // Remove JWT token from localStorage
        localStorage.removeItem("jwt_token");

        // Redirect to the login page after logout
        navigate("/");
    };
    return (
        <nav className="nav navbar navbar-expand-xl navbar-light iq-navbar pt-2 pb-2 px-2" id="boxid">
            <AutoLogout />
            <div className="container-fluid navbar-inner">
                <div className="row flex-grow-1">
                    <div className="col-lg-4 col-md-6 align-items-center d-flex">
                        <li className="nav-item dropdown search-width pt-2 pt-lg-0">
                            <div className="form-group input-group mb-0 search-input">
                                <input type="text" className="form-control" placeholder="Type here to search..." />
                                <span className="input-group-text">
                                    <svg className="icon-20 text-primary" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                                        <path d="M18.0186 18.4851L21.5426 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                    </svg>
                                </span>
                            </div>
                        </li>
                    </div>
                    <div className="col-lg-8 col-md-6 d-flex justify-content-end align-items-center">
                        <li className="nav-item iq-full-screen d-none d-xl-block" id="fullscreen-item">
                            <a href="#" className="nav-link" id="btnFullscreen">
                                <i className="ri-fullscreen-line normal-screen"></i>
                                <i className="ri-fullscreen-exit-line full-normal-screen d-none"></i>
                            </a>
                        </li>
                        <li className="nav-item d-block d-xl-none">
                            <a className="wrapper-menu" data-toggle="sidebar" data-active="true">
                                <div className="main-circle">
                                    <i className="ri-more-fill"></i>
                                </div>
                            </a>
                        </li>
                        <li className="nav-item dropdown">
                            <a href="#" className="nav-link d-flex align-items-center" id="notification-drop" data-bs-toggle="dropdown">
                                <img  src = {logo}style={{ width: 50, height: 50 }} className="img-fluid rounded" alt="user" />
                                <div className="caption d-none d-lg-block">
                                    <h6 className="mb-0 line-height">{ uni_code }</h6>
                                    <span className="font-size-12">Available</span>
                                </div>
                            </a>
                            <div className="p-0 sub-drop dropdown-menu dropdown-menu-end" aria-labelledby="notification-drop">
                                <div className="m-0 -none card">
                                    <div className="py-3 card-header d-flex justify-content-between bg-primary mb-0 rounded-top-3">
                                        <div className="header-title">
                                            <h5 className="mb-0 text-white">All Notifications</h5>
                                            <span className="text-white ">Available</span>
                                        </div>
                                    </div>
                                    <div className="p-0 card-body">
                                        <div className="iq-sub-card d-flex justify-content-center">
                                            <button className="btn btn-primary-subtle" onClick={handleLogout}>
                                                Sign out <i className="ri-login-box-line ms-2"></i>
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
